"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkButtonProps = exports.primaryButtonProps = void 0;

var _package = _interopRequireDefault(require("@cimpress/react-components/package.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const sharedLibVersion = (_package.default.version || '').split('.');
const cimpressComponentsMajorVersion = sharedLibVersion[0] || '13';
const primaryButtonProps = cimpressComponentsMajorVersion === '13' ? {
  type: 'primary'
} : {
  variant: 'primary'
};
exports.primaryButtonProps = primaryButtonProps;
const linkButtonProps = cimpressComponentsMajorVersion === '13' ? {
  type: 'link'
} : {
  variant: 'link'
};
exports.linkButtonProps = linkButtonProps;